import React, { useEffect, useState } from 'react'
import './eval-data-view.styles.scss'
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { getEvalDataFromDb, getUserEvalDataFromDb } from '../../../utils/getDataFromDb';
import { FormTypes, CombineForms } from '@/forms/formTypes'

const EvalDataView = () => {

  const { evalId } = useParams();
  const [ evaluationData, setEvaluationData ] = useState(null);
  const [ evaluations, setEvaluations ] = useState(null);
  const [ formTemplate, setFormTemplate ] = useState({});
  const [ displayData, setDisplayData ] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!evalId) {
      navigate('/404');
      return;
    }
    getEvalData();
    getEvaluations();
  }, [evalId])

  useEffect(() => {
    if (!formTemplate || !evaluations) return;
    compileEvaluationData();
  }, [formTemplate, evaluations])

  function getEvalData() {
    getEvalDataFromDb({
      'evalId': evalId,
      'once': true,
      'callback': callback
    });

    function callback(data) {
      console.log(data);
      setEvaluationData(data[evalId]);
      compileTemplate(data[evalId]);
    }
  }
  function getEvaluations() {
    getUserEvalDataFromDb({
      'evalId': evalId,
      'once': true,
      'callback': callback
    });

    function callback(data) {
      console.log(data);
      setEvaluations(data);
    }
  }

  function compileTemplate(evalData) {
    if (evalData.type && evalData.type === 'eln') {
      evalData.customEval = ['eln'];
      evalData.isbe = true;
    } else if (evalData.type && evalData.type === 'standard') {
      evalData.customEval = ['none'];
      evalData.isbe = true;
    }
    let formObj = CombineForms();    
    console.log(formObj);
    let formArr = [];
    if (evalData.isbe) {
      formArr = Object.values(formObj['isbe'].sections);
    }
    for (let custom of evalData.customEval) {
      if (custom === 'none') continue;
      formArr.push(...Object.values(formObj[custom].sections));
    }
    console.log(formArr);
    const template = {};
    for (let c of formArr) {
      template[c.key] = {
        title: c.title,
        key: c.key,
        type: c.type,
      }
      if (c.type === 'multiple') {
        template[c.key].content = {}
        for (let b of Object.values(c.content)) {
          template[c.key].content[b.key] = {
            title: b.text,
            key: b.key,
            data: {
              total: 0,
            }
          }
        }
      } else if (c.type === 'textarea') {
        template[c.key].data = {
          comments: [],
        }
      } else if (c.type === 'select') {
        template[c.key].data = {
          total: 0,
          avg: 0
        }
      }
    }
    
    setFormTemplate(template);
  }

  async function compileEvaluationData() {
    const completeData = {...formTemplate};
    let evalContent = {}
    for (let evalDoc of Object.values(evaluations)) {
      for (let f of Object.keys(evalDoc)) {
				if (f === 'evalId' || f === 'evalItemId' || f === 'evalSource' || f === 'evalType') {
					continue;
				}
				if (evalContent[f]) {
					evalContent[f].push(evalDoc[f])
				} else {
					evalContent[f] = [evalDoc[f]]
				}
			}
    }
    for (let e of Object.values(formTemplate)) {
      // console.log(e)
      if (e.type === 'multiple') {
        for (let c of Object.values(e.content)) {
          if (evalContent[c.key]) {
            completeData[e.key].content[c.key].data.total = getSum(evalContent[c.key])
          }
        }
      } else if (e.type === 'select') {
        completeData[e.key].data.total = getSum(evalContent[e.key])
        completeData[e.key].data.avg = await getAvg(evalContent[e.key], Object.keys(evaluations).length)
      } else if (e.type === 'textarea') {
        completeData[e.key].data.comments = evalContent[e.key] ? evalContent[e.key] : []
      }
    }
		console.log(completeData)
		setDisplayData(completeData)
  }

  function getSum(arr) {
		const initialValue = 0;
		return arr.reduce(
		  (accumulator, currentValue) => accumulator + currentValue,
		  initialValue
		);
	}

	async function getAvg(arr, total) {
		const sum = await getSum(arr)
		// console.log(sum)
		return (sum / total).toFixed(1)
	}

  return (
    <div className='eval-data-container'>
      <div className='eval-data-content g-card'>
        <button
          className='g-button small-btn'
          onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} />
          Back
        </button>
        <div className="g-space-1"></div>
        <div className='eval-data-header'>
          <h3>{evaluationData?.item.title}</h3>
          {
            (evaluationData?.source === 'checkinout') &&
            <button 
              className='g-button small-btn' 
              onClick={() => navigate(`/admin/evals/${evalId}/checkinout`)}>
              View Check In/Out Data
            </button>
          }
        </div>
        <hr />
        {
						(displayData && Object.keys(displayData).length > 0) 
            ?
						<div className='data-container'>
							<div className='data-header'>
								<h4>Collected Data</h4>
								<p>Evaluations: {Object.values(evaluations).length.toLocaleString()}</p>
							</div>
              <div className="g-space-1"></div>
							{
								(Object.values(evaluations).length > 0) &&
								Object.values(formTemplate).map(cat => (
									(cat.type === 'multiple') 
									?
									<div key={cat.key} className='results-container'>
                    <div className="g-space-1"></div>
										<p className='result-title'>{cat.title}</p>
										<table className='uk-table uk-table-striped'>
											<tbody>
											{
												(displayData[cat.key]) &&
												Object.values(displayData[cat.key].content).map(m => (
													<tr key={m.key}>
														<td>{m.title}</td>
														<td className='total-td' width='80px'>{m.data.total}</td>
													</tr>
												))
												
											}
											</tbody>
										</table>
									</div>
									:
									(cat.type === 'select') 
									?
									<div key={cat.key} className='results-container'>
										{
											(displayData[cat.key]) &&    
											<>
                        <div className="g-space-1"></div>
												<p className='result-title'>{cat.title}</p>
												<table className='uk-table uk-table-striped'>
													<thead>
														<tr>
															<td className='select-td'>
																Strongly Agree
															</td>
															<td className='select-td'>
																Agree
															</td>
															<td className='select-td'>
																Somewhat Agree
															</td>
															<td className='select-td'>
																Disagree
															</td>
															<td className='select-td'>
																Average
															</td>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td className='select-td'>
																{
																	Object.values(evaluations)
																	.filter(ev => ev[cat.key] === 4).length
																}
															</td>
															<td className='select-td'>
																{
																	Object.values(evaluations)
																	.filter(ev => ev[cat.key] === 3).length
																}
															</td>
															<td className='select-td'>
																{
																	Object.values(evaluations)
																	.filter(ev => ev[cat.key] === 2).length
																}
															</td>
															<td className='select-td'>
																{
																	Object.values(evaluations)
																	.filter(ev => ev[cat.key] === 1).length
																}
															</td>
															<td className='select-td'>
																{
																	displayData[cat.key].data.avg
																}
															</td>
														</tr>
													</tbody>
												</table>
											</>
										}
									</div>
									: 
									(cat.type === 'textarea') 
									?
									<div key={cat.key} className='results-container'>
										{
											(displayData[cat.key]) &&    
											<>
                        <div className="g-space-1"></div>
												<p className='result-title'>{cat.title}</p>
												<table className='uk-table uk-table-striped'>
                          <tbody>
													{
                            displayData[cat.key].data.comments.length === 0
                            ?
                            <tr><td>No Comments Recorded...</td></tr>
                            :
														displayData[cat.key].data.comments.map((com, i) => (
															<tr key={com + i}>
																<td>{com}</td>
															</tr>
														))
													}
                          </tbody>
												</table>
											</>
										}
									</div>
									:
									''
								))		
							}
								
							
						</div>
            :
            <p>No evaluation data has been collected yet.</p>
					}
      </div>
    </div>
  )
}

export default EvalDataView